import { render, staticRenderFns } from "./ChangeProposalStatusRowInfo.vue?vue&type=template&id=beaa8988&scoped=true"
import script from "./ChangeProposalStatusRowInfo.vue?vue&type=script&lang=js"
export * from "./ChangeProposalStatusRowInfo.vue?vue&type=script&lang=js"
import style0 from "./ChangeProposalStatusRowInfo.vue?vue&type=style&index=0&id=beaa8988&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaa8988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beaa8988')) {
      api.createRecord('beaa8988', component.options)
    } else {
      api.reload('beaa8988', component.options)
    }
    module.hot.accept("./ChangeProposalStatusRowInfo.vue?vue&type=template&id=beaa8988&scoped=true", function () {
      api.rerender('beaa8988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/ChangeProposalStatusRowInfo.vue"
export default component.exports